export const FILTER_DATA_TYPES = {
  STRING: "string",
  NUMBER: "number",
  DATE: "date",
  STATUS_CODE: "status_code",
  BOOLEAN: "boolean",
};
export const STATUS_CODE_OPERATORS = [{ value: "EQUAL", label: "Equals" }];
export const BOOLEAN_OPERATORS = [{ value: "EQUAL", label: "Equals" }];
export const FILTER_STEPS = {
  SELECT_FIELD: "SELECT_FIELD",
  SELECT_OPERATOR: "SELECT_OPERATOR",
  ENTER_VALUE: "ENTER_VALUE",
};
export const STRING_OPERATORS = [
  { value: "EQUAL", label: "Equals" },
  { value: "LIKE", label: "Contains" },
];

export const NUMBER_OPERATORS = [
  { value: "EQUAL", label: "Equals" },
  { value: "GREATER_THAN", label: "Greater than" },
  { value: "GREATER_THAN_OR_EQUAL", label: "Greater or equal" },
  { value: "LESS_THAN", label: "Less than" },
  { value: "LESS_THAN_OR_EQUAL", label: "Less or equal" },
];

export const DATE_OPERATORS = [
  { value: "EQUAL", label: "On" },
  { value: "LESS_THAN", label: "Before" },
  { value: "LESS_THAN_OR_EQUAL", label: "On or before" },
  { value: "GREATER_THAN", label: "After" },
  { value: "GREATER_THAN_OR_EQUAL", label: "On or after" },
];
export const OPERATORS_BY_TYPE = {
  [FILTER_DATA_TYPES.STRING]: STRING_OPERATORS,
  [FILTER_DATA_TYPES.NUMBER]: NUMBER_OPERATORS,
  [FILTER_DATA_TYPES.DATE]: DATE_OPERATORS,
  [FILTER_DATA_TYPES.STATUS_CODE]: STATUS_CODE_OPERATORS,
  [FILTER_DATA_TYPES.BOOLEAN]: BOOLEAN_OPERATORS,
};
export const ON_DATE_OPERATOR_LABEL = "On";
export const GTE_OPERATOR_LABEL = "Greater or equal";
export const LTE_OPERATOR_LABEL = "Less or equal";
